var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"CheckboxStyled",attrs:{"hide-details":_vm.isHideDetails,"false-value":0,"true-value":1,"disabled":_vm.isDisabled},on:{"change":function($event){return _vm.$emit('change-event',$event)}},model:{value:(_vm.currentData),callback:function ($$v) {_vm.currentData=_vm._n($$v)},expression:"currentData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }